import { Swiper } from 'swiper';
import {Navigation, Autoplay, Pagination, Grid} from "swiper/modules";
Swiper.use([Navigation, Autoplay, Pagination, Grid]);

export default () => {
    const nodeSelectors = {
        container: '[js-case-actions-slider="container"]',
        slider: '[js-case-actions-slider="slider"]',
        prev: '[js-case-actions-slider="prev"]',
        next: '[js-case-actions-slider="next"]',
        pagination: '[js-case-actions-slider="pagination"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let sliderCaseAtion = new Swiper(sliderEl, {
                slidesPerView: 1,
                grid: {
                    rows: 6,
                    fill: 'row', // or 'column'
                },
                speed: 500,
                autoplay: {
                    delay: 2500
                },
                spaceBetween: 20,
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },
                pagination: {
                    el: container.querySelector(nodeSelectors.pagination),
                },
                breakpoints: {
                    // when window width is >= 480px
                    768: {
                        slidesPerView: 2,
                        grid: {
                            rows: 3,
                            fill: 'row', // or 'column'
                        },
                    },
                    // when window width is >= 640px
                    1024: {
                        slidesPerView: 3,
                        grid: {
                            rows: 3,
                            fill: 'row', // or 'column'
                        },
                    }
                }

            });
        })
    }

    return Object.freeze({
        init,
    })
}